module.exports = __webpack_public_path__ + "img/katarina_bathrooms_1.a311eb71.jpg";